@if (closable()) {
    <woa-icon-button class="message-close" [type]="IconButtonType.CLOSE"
                     (onActivate)="onClose.emit()"></woa-icon-button>
}
<div class="message-decorator">
    @if (displayShowIcon()) {
        <woa-icon class="message-decorator-icon" [name]="iconName()"></woa-icon>
    }
    <ng-content></ng-content>
</div>
<!--suppress JSUnusedGlobalSymbols -->
<div class="message-body" #messageBody>
    @if (displayText()) {
        <div class="message-body-text" [innerHTML]="displayText() | translate: displayTranslationParams() | html"></div>
    }
    <div class="message-body-links">
        @if (displayLink()) {
            <woa-link [link]="displayLink()" [plain]="true" (onActivate)="linkActivated()"></woa-link>
        }
        <ng-content select="woa-link"></ng-content>
    </div>
</div>
